<script lang="ts">
	import { getImageDimensions, type SizeBlok } from '$lib/storyblok/types';
	import { page } from '$app/stores';
	import Image from '$lib/components/Image/Image.svelte';
	import RichText from '$lib/components/Storyblok/RichText.svelte';

	export let sizeData: SizeBlok;

	const matchNumberAndUnit = (stringToMatch: string) => {
		const numberMatcher =
			/[+-]?(?<number>\d+(?:[.,]\d+)?(\s[x]\s)?(\d+(?:[.,]\d+)?)?)\s*(?<unit>\w+)?/;
		return stringToMatch.match(numberMatcher)?.groups;
	};

	$: values = $page.data?.product?.options?.find((s) => s.name === 'Länge')?.values;
	$: measurementsData = JSON.parse($page.data?.product?.measurement_table?.value || '{}');
	$: headerLength = measurementsData?.headers?.length;
</script>

{#if (values?.length ?? 0) > 0}
	<ul class="flex flex-wrap gap-3">
		{#each values as value}
			{@const matchedValue = matchNumberAndUnit(value)}

			<li
				class={'w-12 h-12 border border-1 border-dark-quaternary rounded-full text-h-12 text-accent-primary select-none flex flex-col justify-center items-center'}
			>
				{#if matchedValue !== null}
					{matchedValue?.number}
					<span class="block"> </span>
					{matchedValue?.unit}
				{:else}
					{value}
				{/if}
			</li>
		{/each}
	</ul>
{/if}
{#if sizeData}
	{#if sizeData?.image?.filename}
		{@const imageDimensions = getImageDimensions(sizeData.image)}
		<Image
			src={sizeData.image.filename}
			alt={sizeData.image.alt || undefined}
			layout="responsive"
			width={imageDimensions?.width || 600}
			height={imageDimensions?.height || 400}
			class="object-contain"
		/>
	{/if}
	<span class="uppercase font-bold text-h-18">{sizeData.title}</span>
	<RichText text={sizeData.description} />
	{#if sizeData.showPimDetails !== false}
		<div class={`grid grid-cols-${headerLength} mt-5 mb-10 gap-y-3`}>
			{#each measurementsData?.headers as value}
				<div class="font-bold uppercase">
					{value}
				</div>
			{/each}

			{#each measurementsData?.data as value}
				{#each measurementsData?.headers as _, j}
					<div>
						{value[j]}
					</div>
				{/each}
			{/each}
		</div>
	{/if}
{/if}
